var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: [_vm.$.board_container, "board_container"] },
    [
      _vm.showFilterStub
        ? [
            _c(
              "div",
              { class: _vm.$.no_tasks_stub },
              [
                _c("svgImage", {
                  class: _vm.$.stub_svg,
                  attrs: { name: "comment-hub-no-search" },
                }),
                _vm._v(" "),
                _c("div", { class: _vm.$.no_tasks_text }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.locale("board_no_filtered_tasks")) +
                      "\n      "
                  ),
                ]),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.showSkeleton ? [_c("board-skeleton")] : _vm._e(),
      _vm._v(" "),
      _vm.showColumns
        ? [
            _c(
              "draggable",
              _vm._b(
                {
                  class: [
                    _vm.$.columns_container,
                    "gantt_scroll",
                    "thumb-spaced",
                    _vm.columnDragging || _vm.taskDragging
                      ? _vm.$.drag_active
                      : "",
                  ],
                  attrs: {
                    group: { name: "columns" },
                    value: _vm.columns,
                    move: _vm.onColumnMove,
                  },
                  on: { start: _vm.onColumnDragStart, end: _vm.onColumnDrop },
                },
                "draggable",
                {
                  disabled: _vm.taskCardEditing || _vm.taskSettingsInfo,
                  group: "columns",
                  animation: 200,
                  filter: ".add_field_option",
                  ghostClass: _vm.$.drop_preview,
                  handle: ".column_drag_handle",
                  forceFallback: true,
                  fallbackClass: _vm.$.column_drag,
                  fallbackTolerance: 5,
                  chosenClass: _vm.$.column_drag_chosen,
                  easing: "cubic-bezier(1, 0, 0, 1)",
                  scrollSensitivity: 300,
                  scrollSpeed: 25,
                },
                false
              ),
              [
                _vm._l(_vm.columns, function (column, index) {
                  return _c("column", {
                    key: column.id + "_" + column.value,
                    style: { width: _vm.colWidth + "px" },
                    attrs: {
                      "is-collapsed": !!_vm.collapsed[column.id],
                      tasksMap: _vm.tasksMap,
                      projectResources: _vm.projectResources,
                      column: column,
                      order: [index, _vm.columns.length],
                      taskDragging: _vm.taskDragging,
                      acceptDragItem: !_vm.dragPutRestricted.includes(
                        column.id
                      ),
                      canDragTasks: _vm.canDragTasks,
                      boardHeight: _vm.boardHeight,
                      draftTasks: _vm.draftTasks,
                    },
                    on: {
                      onTaskDrop: _vm.onTaskDrop,
                      onCollapse: _vm.onCollapse,
                      taskChange: _vm.taskChange,
                      createTask: _vm.createTask,
                      taskDragStart: _vm.taskDragStart,
                    },
                  })
                }),
                _vm._v(" "),
                _vm.groupingFieldInfo.isCustom && _vm.canEditCustomFields
                  ? _c(
                      "div",
                      { class: [_vm.$.add_option, "add_field_option"] },
                      [
                        _c("iconButton", {
                          class: _vm.$.add_option__button,
                          attrs: {
                            icon: { name: "plus-1", type: "regular", size: 24 },
                          },
                          on: { onClick: _vm.editField },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              2
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }